// src/pages/admin/Admin.jsx
import React from 'react';
import styled from 'styled-components';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../../store/auth';

const Shell = styled.main` padding: 18px 0 24px; `;
const Container = styled.div` width:min(1400px,96vw); margin:0 auto; padding:0 18px; `;

const TopBar = styled.div`
  display:flex; align-items:center; justify-content:space-between; gap:10px; margin-bottom:12px;
  h1{ margin:0; }
`;

const Tabs = styled.div` display:flex; gap:8px; margin-bottom:14px; flex-wrap:wrap; `;

const TabLink = styled(NavLink)`
  padding:10px 14px; border-radius:12px; border:1px solid var(--bdr);
  background:var(--card); box-shadow:var(--shadow); font-weight:600;
  display:inline-flex; align-items:center; justify-content:center;
  &.active{ background:var(--primary); color:var(--primaryFg); border-color:transparent; }
  &:hover{ transform: translateY(-1px); box-shadow: 0 12px 28px rgba(0,0,0,.12); }
`;

const Actions = styled.div` display:flex; gap:10px; flex-wrap:wrap; `;
const Btn = styled.button`
  padding:10px 14px; border-radius:14px; border:1px solid var(--bdr);
  background:var(--card); font-weight:700;
`;

export default function Admin(){
  const logout = useAuth(s => s.logout);

  return (
    <Shell>
      <Container>
        <TopBar>
          <h1>Админ-панель</h1>
          <Actions><Btn onClick={logout}>Выйти</Btn></Actions>
        </TopBar>

        <Tabs>
          <TabLink to="/admin/properties">Квартиры</TabLink>
          <TabLink to="/admin/foreign" end={false}>Зарубежная</TabLink>
          <TabLink to="/admin/suburban" end={false}>Загородная</TabLink>
          <TabLink to="/admin/commercial-rent" end={false}>Коммерческие</TabLink>
          <TabLink to="/admin/parking" end={false}>Паркинги</TabLink>
          
          <TabLink to="/admin/posts">Посты</TabLink>
          <TabLink to="/admin/services">Услуги</TabLink>
          <TabLink to="/admin/corporation">Корпорация</TabLink>
          <TabLink to="/admin/amenities">Удобства</TabLink>
          <TabLink to="/admin/managers">Менеджеры</TabLink>
          
          <TabLink to="/admin/leads">Лиды</TabLink>
          <TabLink to="/admin/media">Медиа</TabLink>
          <TabLink to="/admin/currencies">Курс валют</TabLink>
          <TabLink to="/admin/regions">Регионы</TabLink>
          <TabLink to="/admin/districts">Районы</TabLink>
          {/* Новые вкладки */}
          <TabLink to="/admin/catalogs">Каталоги</TabLink>
          <TabLink to="/admin/collections">Подборки</TabLink>
          <TabLink to="/admin/awards">Награды</TabLink>
        </Tabs>

        <Outlet />
      </Container>
    </Shell>
  );
}
